import buildSnippets from "../openapi/snippets.js";
import { type Operation } from "../openapi/types.ts";
import CodeBlock from "./CodeBlock.jsx";
import { Tab, Tabs } from "./Tabs.jsx";

// <Snippets method="POST" path="/authenticate" body={{ … }} />
//
// O mesmo gerador de quatro linguagens da API Reference, para os guias. Um
// guia que só mostra curl deixa quem integra em JavaScript, Python ou PHP
// traduzindo na mão; e escrever as quatro versões no .mdx é garantir que três
// delas envelheçam. Aqui elas derivam de method/path/body, como na referência.
//
// `base` é o prefixo da URL: por padrão o token do sandbox, que o CodeBlock
// troca pelo valor real; nos passos de um quickstart, `$BASE`. `token` idem
// para o Bearer. Rota de autenticação não leva Authorization, como no gerador.
interface SnippetsProps {
  method?: string;
  path: string;
  query?: string;
  body?: unknown;
  base?: string;
  token?: string;
}

const LANG_CLASS: Record<string, string> = { cURL: "bash", JavaScript: "javascript", Python: "python", PHP: "php" };

export default function Snippets({
  method = "GET",
  path,
  query = "",
  body,
  base = "{SANDBOX_API}",
  token = "$TOKEN",
}: SnippetsProps) {
  const example = body === undefined ? null : typeof body === "string" ? body : JSON.stringify(body, null, 2);
  const op: Operation = {
    id: "",
    method: method.toUpperCase(),
    path: path + query,
    title: "",
    desc: "",
    deprecated: false,
    operationId: null,
    params: [],
    body:
      example === null
        ? null
        : { required: true, description: "", contentType: "application/json", example, schema: null },
    responses: [],
    codeSamples: null,
    rateLimit: null,
    restricted: null,
    bestPractice: null,
    statusNotes: null,
  };
  const { snippets, langs } = buildSnippets(op, { baseVar: base, tokenVar: token });
  return (
    <Tabs>
      {langs.map((lang) => (
        <Tab key={lang} label={lang}>
          <CodeBlock>
            <code className={`language-${LANG_CLASS[lang] ?? lang.toLowerCase()}`}>{snippets[lang]}</code>
          </CodeBlock>
        </Tab>
      ))}
    </Tabs>
  );
}
